import React, { useEffect, useState } from 'react'

export interface WebSocketProps {
  url?: string
  onOpen: (event: Event) => void
  onMessage: (event: MessageEvent) => void
  onClose: (event: CloseEvent) => void
  onError: (event: Event) => void
  heartbeatMs?: number
  messageToSend?: any
}

export const ChatWebSocket = ({ url, onOpen, onMessage, onClose, onError, heartbeatMs, messageToSend }: WebSocketProps) => {
  const [socket, setSocket] = useState<WebSocket>()

  const startNewSocket = () => {
    if (url) {
      console.log('Starting new WebSocket Connection with url', url)
      const newSocket = new WebSocket(url)
      setSocket(newSocket)
      newSocket.onopen = onOpen
      newSocket.onmessage = onMessage
      newSocket.onclose = onClose
      newSocket.onerror = onError
      return newSocket
    }
  }

  useEffect(() => {
    const newSocket = startNewSocket()
    return () => {
      if (newSocket && newSocket.readyState === WebSocket.OPEN) {
        newSocket.close()
      }
    }
  }, [url])

  useEffect(() => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.onopen = onOpen
      socket.onmessage = onMessage
      socket.onclose = onClose
      socket.onerror = onError
      return () => {
        socket?.removeEventListener('open', onOpen)
        socket?.removeEventListener('message', onMessage)
        socket?.removeEventListener('close', onClose)
        socket?.removeEventListener('error', onError)
      }
    }
  }, [socket, onOpen, onMessage, onClose, onError])

  useEffect(() => {
    if (heartbeatMs) {
      const interval = setInterval(() => {
        if (socket && socket.readyState === WebSocket.OPEN) {
          socket.send(JSON.stringify({ type: 'ping' }))
        } else {
          startNewSocket()
        }
      }, heartbeatMs)
      return () => clearInterval(interval)
    }
  }, [heartbeatMs, socket, socket?.readyState, startNewSocket])

  useEffect(() => {
    if (messageToSend && socket && socket.readyState === WebSocket.OPEN) {
      // console.log('Sending message over websocket', JSON.stringify(messageToSend))
      socket.send(JSON.stringify(messageToSend))
    }
  }, [messageToSend, socket, socket?.readyState])

  return <></>
}
